import { TicketLogDto } from "./TicketLogDto";
import { TicketLogModel } from "./TicketLogModel";

export const transformTicketLogDtoToModel = (
  dto: TicketLogDto
): TicketLogModel => dto;
